import { createRouter, createWebHashHistory } from 'vue-router'
import reportsView from '@/views/reportsView.vue'
import editorView from '@/views/editorView.vue'
import questionView from '@/views/questionView.vue'
import visitsView from '@/views/visitsView.vue'
import bookView from '@/views/bookView.vue'
import loginView from '@/views/loginView.vue'
import resultView from '@/views/resultView.vue'
import editQuestionView from '@/views/editQuestionView.vue'

//
import homeView from '@/views/homeView.vue'
import listView from '@/views/listView.vue'
import questionsView from '@/views/appQuestionView.vue'
import successView from '@/views/successView.vue'
import detailView from '@/views/detailView.vue'
const routes = [
  {
    path: '/reports',
    name: 'reports',
    component: reportsView
  },
  {
    path: '/editor',
    name: 'editor',
    component: editorView
  },
  {
    path: '/question',
    name: 'question',
    component: questionView
  },
  {
    path: '/visits',
    name: 'visits',
    component: visitsView
  },
  {
    path: '/book',
    name: 'book',
    component: bookView
  },
  {
    path: '/login',
    name: 'login',
    component: loginView
  },
  {
    path: '/result',
    name: 'result',
    component: resultView
  },
  {
    path: '/edit',
    name: 'edit',
    component: editQuestionView
  },
  //   app
  {
    path: '/',
    name: 'homeView',
    component: homeView
  },
  {
    path: '/list',
    name: 'listView',
    component: listView
  },
  {
    path: '/questions',
    name: 'questionView',
    component: questionsView
  },
  {
    path: '/success',
    name: 'success',
    component: successView
  },
  {
    path: '/detail',
    name: 'detail',
    component: detailView
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
